var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowCircleHollow = function SvgArrowCircleHollow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666748 7.99992C0.666748 12.05 3.94999 15.3333 8.00008 15.3333C12.0502 15.3333 15.3334 12.05 15.3334 7.99992C15.3334 3.94983 12.0502 0.666586 8.00008 0.666586C3.94999 0.666586 0.666748 3.94983 0.666748 7.99992ZM8.00008 13.9999C4.68637 13.9999 2.00008 11.3136 2.00008 7.99992C2.00008 4.68621 4.68637 1.99992 8.00008 1.99992C11.3138 1.99992 14.0001 4.68621 14.0001 7.99992C14.0001 11.3136 11.3138 13.9999 8.00008 13.9999Z",
    fill: "#0357FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4714 9.80474C11.7317 9.54439 11.7317 9.12228 11.4714 8.86193L8.47137 5.86193C8.21102 5.60158 7.78891 5.60158 7.52856 5.86193L4.52856 8.86193L5.47137 9.80474L7.99997 7.27614L10.5286 9.80474C10.7889 10.0651 11.211 10.0651 11.4714 9.80474Z",
    fill: "#0357FF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowCircleHollow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-circle-hollow.02895329.svg";
export { ForwardRef as ReactComponent };